
import { WorldCountry } from '../types';
import { southAfricaExpanded2 } from './southAfricaExpansion2';
import { nigeriaExpanded2 } from './nigeriaExpansion2';

export const africaExpansion2: WorldCountry[] = [
  southAfricaExpanded2,
  nigeriaExpanded2
];
